import { render } from "./AuthProviderSignInButton.vue?vue&type=template&id=7920270a&scoped=true&ts=true"
import script from "./AuthProviderSignInButton.vue?vue&type=script&lang=ts"
export * from "./AuthProviderSignInButton.vue?vue&type=script&lang=ts"

import "./AuthProviderSignInButton.vue?vue&type=style&index=0&id=7920270a&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7920270a"]])

export default __exports__